import http from './http'
import { getToken } from './auth'

const headers = () => ({
  'Authorization': 'Bearer ' + getToken(),
  'Content-Type': 'application/json',
})

export async function getDashboard() {
  const { data } = await http.get('/platform/dashboard', { headers: headers() })
  return data
}

export async function getCompanies({ page = 1, limit = 20, search = '', status = '' } = {}) {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) })
  if (search) params.set('search', search)
  if (status) params.set('status', status)
  const { data } = await http.get(`/platform/companies?${params}`, { headers: headers() })
  return data
}

export async function createCompany(payload) {
  const { data } = await http.post('/platform/companies', payload, { headers: headers() })
  return data
}

/** { name?, phone? (E.164 or null), planId? (or null) } */
export async function updateCompany(id, payload) {
  const { data } = await http.patch(`/platform/companies/${id}`, payload, { headers: headers() })
  return data
}

export async function getUsers({ page = 1, limit = 20, search = '', status = '' } = {}) {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) })
  if (search) params.set('search', search)
  if (status) params.set('status', status)
  const { data } = await http.get(`/platform/users?${params}`, { headers: headers() })
  return data
}

export async function getCompanyDetail(id) {
  const { data } = await http.get(`/platform/companies/${id}`, { headers: headers() })
  return data
}

export async function updateTrial(id, payload) {
  const { data } = await http.patch(`/platform/companies/${id}/trial`, payload, { headers: headers() })
  return data
}

export async function suspendCompany(id) {
  const { data } = await http.post(`/platform/companies/${id}/suspend`, {}, { headers: headers() })
  return data
}

export async function reactivateCompany(id) {
  const { data } = await http.post(`/platform/companies/${id}/reactivate`, {}, { headers: headers() })
  return data
}

export async function updateUser(id, payload) {
  const { data } = await http.patch(`/platform/users/${id}`, payload, { headers: headers() })
  return data
}

export async function deleteUser(id) {
  const { data } = await http.delete(`/platform/users/${id}`, { headers: headers() })
  return data
}

export async function resetUserPassword(id) {
  const { data } = await http.post(`/platform/users/${id}/reset-password`, {}, { headers: headers() })
  return data
}

export async function deactivateUser(id) {
  const { data } = await http.post(`/platform/users/${id}/deactivate`, {}, { headers: headers() })
  return data
}

export async function activateUser(id) {
  const { data } = await http.post(`/platform/users/${id}/activate`, {}, { headers: headers() })
  return data
}

export async function createCompanyUser(companyId, payload) {
  const { data } = await http.post(`/platform/companies/${companyId}/users`, payload, { headers: headers() })
  return data
}

export async function assignPlan(companyId, planId) {
  const { data } = await http.patch(`/platform/companies/${companyId}/plan`, { planId }, { headers: headers() })
  return data
}

export async function getPlans() {
  const { data } = await http.get('/platform/plans', { headers: headers() })
  return data
}

export async function createPlan(payload) {
  const { data } = await http.post('/platform/plans', payload, { headers: headers() })
  return data
}

export async function updatePlan(id, payload) {
  const { data } = await http.patch(`/platform/plans/${id}`, payload, { headers: headers() })
  return data
}

export async function deletePlan(id) {
  const { data } = await http.delete(`/platform/plans/${id}`, { headers: headers() })
  return data
}

export async function expireTrials() {
  const { data } = await http.post('/platform/expire-trials', {}, { headers: headers() })
  return data
}
